import React, {useContext, memo} from 'react';
import './RestaurantNavigation.less';
import {NavigationItem} from '../navigation-item/NavigationItem';

import OrdersIcon from 'new-images/orders.svg';
import ProfileIcon from 'new-images/profile.svg';
import {IconBadgeColors} from "elements/icon-badge/IconBadge";
import {List} from "elements/list/List.tsx";
import {ListItem} from "elements/list-item/ListItem.tsx";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const RestaurantNavigation = memo(({onOrdersClick, onProfileClick}) => {
	const translations = useContext(TranslationsContext);

	return (
		<List isSplitterPadding>
			<ListItem key="orders" onClick={onOrdersClick} isResponsive>
				<NavigationItem
					name={getSafeTranslation('RestaurantNavigation.ordersLabel', translations)}
					icon={OrdersIcon}
					iconColor={IconBadgeColors.dark}
				/>
			</ListItem>
			<ListItem key="profile" onClick={onProfileClick} isResponsive>
				<NavigationItem
					name={getSafeTranslation('RestaurantNavigation.profileLabel', translations)}
					icon={ProfileIcon}
					iconColor={IconBadgeColors.dark}
				/>
			</ListItem>
		</List>
	);
});
